import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const ExternalRedirect: React.FC = () => {
    const history = useHistory();

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data?.type === 'ROUTER_PUSH' && event.data.path) {
                history.push(event.data.path);
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [history]);

    return null;
};

export default ExternalRedirect;
